import PropTypes from 'prop-types';
import PublicLayoutWrapper from './styles';
import { ReactNode } from 'react';

const PublicLayout = ({ children }: { children: ReactNode }) => (
  <PublicLayoutWrapper>
    <div className="main-public text-sm">
      <div className='public-image'>
        <img
          src='/images/ecommerce-login.png'
          alt='public-image'
          width={741}
          height={386}
        />
      </div>
      <div className='public-content'>
        {children}
      </div>
    </div>
  </PublicLayoutWrapper>
);

PublicLayout.propTypes = {
  children: PropTypes.any,
};

export default PublicLayout;
